import React from 'react'
import { CrossClientQueryResultCellProps } from './types'
import { LinkButton } from '../../../../components/Button/LinkButton'
import { selectCrossClientClients } from '../../../../store/crossClient/crossClientResults'
import { useAppSelector } from '../../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { Button } from '../../../../components/Button/Button'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

export const CrossClientQueryResultButtonsCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const currentUserId = useAppSelector(selectSafeAuthenticatedUser).id

  const client = clients[result.clientId]

  const disabled = !client || (client.owner?.ownerId && client.owner.ownerId !== currentUserId)

  if (disabled) {
    return (
      <div className='d-flex gap-2'>
        <Tooltip className='zocks-text-gray-500 position-fixed' placement='top' title='Only the contact owner can email this client.'>
          <Button variant='borderless' className='p-2 cross-client-cta' disabled>
            <i className='bi bi-envelope' />
          </Button>
        </Tooltip>
        <Tooltip className='zocks-text-gray-500 position-fixed' placement='top' title='Only the contact owner can view  client details.'>
          <Button variant='borderless' className='p-2 cross-client-cta' disabled>
            <i className='bi bi-arrow-up-right' />
          </Button>
        </Tooltip>
      </div>
    )
  }

  return (
    <div className='d-flex gap-2'>
      <LinkButton variant='borderless' className='p-2 cross-client-cta' to={`/email/new?contactId=${result.clientId}`} target='_blank'>
        <i className='bi bi-envelope' />{' '}
      </LinkButton>
      <LinkButton variant='borderless' className='p-2 cross-client-cta' to={`/library/manage-contacts/contacts/${result.clientId}`} target='_blank'>
        <i className='bi bi-arrow-up-right' />
      </LinkButton>
    </div>
  )
}
